import { useMutation, useQuery } from '@apollo/client';
import {
  AppContext,
  ContentDeciderContainer,
  PageLoading,
  toast,
  Loader
} from '@nile/components';
import {
  AccountClient,
  GET_PERSONALIZATION_BY_NAME,
  SAVE_PERSONALIZATION,
  useCachedQuery
} from '@nile/graphql';
import ViewSheet from '@nile/mangifera/src/Components/Sheets/ViewSheet';
import {
  GET_TICKETVIEW,
  UPDATE_TICKET_VIEW
} from '@nile/mangifera/src/Graphql/Mutations/ticketview';
import envConfig from '@nile/home/src/Config/env';
import React, { useCallback, useContext } from 'react';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

const LoaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 10px;
`;

function EditViewType(props) {
  const appContext = useContext(AppContext);
  const context = useContext(TicketContext);
  const { user } = appContext;
  const { match } = props;
  const id = match.params.id;
  const {
    loading: customLoading,
    error: customError,
    data: personalization,
    refetch: personalizationRefetch
  } = useCachedQuery(GET_PERSONALIZATION_BY_NAME, {
    variables: {
      userId: user.userId,
      category: 'TicketView',
      name: id
    },
    client: AccountClient
  });

  // const [personalization, setPersonalization] = useState({})
  const { loading, error, data, refetch } = useQuery(GET_TICKETVIEW, {
    fetchPolicy: 'network-only',
    variables: { id }
  });

  const back = useCallback(() => {
    context.closeTab();
  }, []); // eslint-disable-line

  const [savePersonalization] = useMutation(SAVE_PERSONALIZATION, {
    client: AccountClient
  });

  const [updateTicketView] = useMutation(UPDATE_TICKET_VIEW, {
    onCompleted({ updateTicketView }) {
      /* Close sheet container once an employee created */
      if (updateTicketView) {
        // notifyUpdateToCallee(updateTicketView);
      }
    },
    update(cache, { data }) {},
    onError() {
      // toast('error', 'Something went wrong');
    }
  });

  const actions = {
    primaryAction: updateTicketView,
    savePersonalization: savePersonalization,
    // setPersonalization: setPersonalization,
    back: back
  };

  if (customLoading || loading)
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );

  if (customError) return <div>error...</div>;

  return (
    <ViewSheet
      view={data?.getTicketView}
      personalization={personalization?.getPersonalizationByCategoryAndName}
      actions={actions}
      appContext={appContext}
      context={context}
      loading={customLoading || loading}
      entityShareKey={'updateEntityShare'}
      entityShare={data?.getTicketView?.entityShare}
    />
  );
}

export default withRouter(EditViewType);
